<template>
  <div id="LinkPayPage" class="link-pay-root">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      title="سامانه لینک پرداخت"
      :description="pageDescription"
      :show-back="true"
      back-route="LoginPage"
      wrap-class="link-pay-page netpa-list-page-card-wrap--inset netpa-list-page-card-wrap--centered no-print"
    >
      <template slot="toolbar">
        <div class="link-pay-toolbar" dir="rtl">
          <button type="button" class="link-pay-qr-toggle" @click="QrCode = !QrCode">
            <i class="fas fa-qrcode ml-2" aria-hidden="true"></i>
            {{ QrCode ? 'بازگشت به فرم' : 'دریافت QR Code' }}
          </button>
        </div>
      </template>

      <div v-show="!QrCode">
        <form id="div1" class="link-pay-form text-center w-100" dir="rtl">
          <div class="row">
            <div class="col-md-5 col-12">
              <div class="link-pay-section-title">اطلاعات حساب</div>
              <div v-if="!IsQuery" class="link-pay-shenase-row">
                <input
                  autocomplete="off"
                  class="form-control text-center link-pay-input"
                  id="Shenase"
                  type="number"
                  placeholder="شناسه واریز"
                  v-model="Shenase"
                  v-mask="'####################'"
                />
                <button
                  type="button"
                  class="link-pay-check-btn"
                  @click="CheckupShenase()"
                  dir="ltr"
                >
                  بررسی
                </button>
              </div>

              <div v-if="Result != null" class="link-pay-result-summary">
                <span class="text-secondary">مشخصات:</span>
                <span class="text-dark mr-2">{{ Result.nameFamily }}</span>
                <span class="mr-2">—</span>
                <span class="text-dark" dir="ltr">{{ Result.desNoe }}</span>
                <template v-if="Result.tblSarfaslTypeId == 1">
                  <span class="mr-2">— سررسید قسط</span>
                  <span class="text-danger" dir="ltr">{{ Result.minTarGhestBedehkar }}</span>
                </template>
              </div>

              <div class="link-pay-amount-wrap">
                <input
                  class="form-control text-center link-pay-input link-pay-amount-input"
                  id="Mab"
                  :disabled="FixVariz"
                  v-model="Mablagh"
                  dir="ltr"
                  type="number"
                  placeholder="مبلغ واریزی (ریال)"
                />
                <div class="link-pay-amount-meta">
                  <span class="link-pay-amount-formatted">{{ $Comma3ragham(Mablagh) }}</span>
                  <span class="link-pay-amount-words">{{ ToPersian(Mablagh) }} ریال</span>
                </div>
              </div>

              <div class="link-pay-section-title link-pay-section-title--spaced">اطلاعات واریزکننده</div>
              <div class="link-pay-fields">
                <input
                  class="form-control text-center link-pay-input required"
                  type="text"
                  placeholder="نام و نام خانوادگی"
                  :value="NameFamily"
                  @input="onNameFamilyInput"
                  :disabled="IsLinkPayCustom"
                />
                <input
                  class="form-control text-center link-pay-input required"
                  dir="ltr"
                  type="number"
                  @keypress="$ValidNumber($event, 11)"
                  placeholder="شماره تلفن"
                  v-model="Mobile"
                  :disabled="IsLinkPayCustom"
                />
                <textarea
                  class="form-control text-center link-pay-input link-pay-textarea"
                  placeholder="توضیحات"
                  maxlength="300"
                  rows="2"
                  v-model="Description"
                  :disabled="IsLinkPayCustom"
                ></textarea>
              </div>

              <div class="link-pay-captcha-wrap">
                <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
              </div>
            </div>

            <div class="col-md-7 col-12 link-pay-payment-col">
              <payment
                v-if="wwwtblShobeid != null"
                @GatewayCode="Get_GatewayCode"
                @FixVarizGhestHasJarime="FixVarizGhestHasJarime"
                @FixVarizGhest="FixVarizGhest"
                :wwwtblShobeid="wwwtblShobeid"
              >
                <template v-slot:ContentButtonPayment>
                  <button
                    id="BtnPayment"
                    type="button"
                    class="link-pay-submit-btn"
                    :class="Result == null || Number(Mablagh) < 10000 ? 'link-pay-submit-btn--disabled' : 'link-pay-submit-btn--active'"
                    :disabled="Result == null || Number(Mablagh) < 10000"
                    @click.prevent="Payment"
                  >
                    واریز {{ $Comma3ragham(Mablagh) }} ریال
                  </button>
                  <div id="AletSumMab" class="alert alert-info link-pay-settled-alert d-none">
                    تسهیلات انتخابی شما تسویه شده است. برای اطمینان بیشتر با
                    {{ $session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' }}
                    / شعبه تماس بگیرید.
                  </div>
                </template>
              </payment>
              <div class="alert alert-warning link-pay-hint-alert" v-else>
                برای ادامه، شناسه واریز را وارد کرده و دکمه «بررسی» را بزنید تا درگاه پرداخت نمایش داده شود.
              </div>
            </div>
          </div>
        </form>
      </div>

      <div v-show="QrCode" class="link-pay-qr-panel" dir="rtl">
        <div class="link-pay-qr-panel__content text-center">
          <div id="qrcode" class="link-pay-qr-box">
            <h4 class="link-pay-qr-name">{{ Result != null ? Result.nameFamily : '' }}</h4>
            <qrcode-vue :value="value" :size="size" :render-as="'svg'" level="H" />
            <a class="link-pay-qr-link" :href="value" dir="ltr">{{ value }}</a>
          </div>
        </div>
        <div class="link-pay-qr-panel__actions">
          <button type="button" class="link-pay-print-btn" @click="printQr">
            <i class="fas fa-print ml-2" aria-hidden="true"></i>
            پرینت QR Code
          </button>
        </div>
      </div>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import Payment from '../CmpNetPa/Payment.vue'
import Loading from '../Tools/NetPa/Loading.vue'
import NetPaListPageCard from '../Tools/NetPa/NetPaListPageCard.vue'
import QrcodeVue from 'qrcode.vue'
import html2pdf from 'html2pdf.js'
import Num2persian from 'num2persian'
import CaptchaBox from '../CmpLogin/CaptchaBox.vue'
// import loading from '../Tools/NetPa/Loading.vue'
// import VueRecaptchaEh from "vue-recaptcha-eh";
export default {
  components: {
    Payment,
    NetPaListPageCard,
    Loading,
    QrcodeVue,
    CaptchaBox,
  },
  computed: {
    pageDescription() {
      const name = this.$session.get('NameSandogh')
      return name ? `واریز و پرداخت از طریق لینک — ${name}` : 'واریز و پرداخت از طریق لینک'
    },
  },
  data() {
    return {
            captchaText:"",
      captchaId:"",
      CaptchaValid:false,
      captchaCode: '',
      userInput: '',
      result: '',
      width: 150,
      height: 50,

      codeMeli: '',
      QrCode: false,
      value: window.location.href,
      size: 300,
      appsettings: {},
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenasNew',
        Token: '',
      },
      Resultcmb: -1,
      ShenaseOzv: null,
      ListModel: null,
      IsLoad: false,
      DepositType: 1,
      Shenase: '',
      LinkId: '',
      VCode: '',
      Mablagh: '',
      NameFamily: '',
      Mobile: '',
      Description: '',
      Result: null,
      GatewayCode: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenaseVarizNew',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowVCode: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByVCNew',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowGetShenase: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      FixVariz: false,
      loadingRender: false,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      IsQuery: false,
      IsLinkPay: false,
      IsLinkPayCustom: false,
      wwwtblShobeid: null,
      appsettings: {},
    }
  },
  methods: {
    stripNameQuotesForSend(str) {
      return (str == null ? '' : String(str)).replace(/['"]/g, '')
    },
    onNameFamilyInput(e) {
      this.NameFamily = this.stripNameQuotesForSend(e.target.value)
    },
    onCaptchaValid({ valid, captchaId, userInput }) {     
    this.CaptchaValid = valid;
    this.captchaId = captchaId;
    this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    ToPersian(number) {
      return Num2persian(number)
    },
    gettblCustomer() {
      this.loading = true
      var settings = {
        method: 'Post',
        url: this.$GetapiBase()+ 'Setting',
        headers: {},
        data: null,
      }
      var axios = require('axios')
      //   console.log('settings',settings);
      axios(settings).then((result) => {
        this.$PostData({
          ArryfildValue: {},
          Action: 'GetTblCustomer',
          method: 'GET',
          Token: '',
        })
          .then((data) => {
            // console.log('dataaa',data);
            this.$store.state.NameSandogh = data.name
            this.$session.set('NameSandogh', data.name)
            this.$session.set('CustCode', data.custCode)
            document.title = ' خدمات الکترونیکی ' + data.name
            this.loading = false
            this.CheckupLinkPay()
          })
          .catch(function (error) {
            //console.log(error)
          })
      })
    },
    // getDepositType(val) {
    //   this.DepositType = val
    //   this.Result = null
    //   // if(val==3){

    //   // }
    // },

    applyShenaseSuccess(result) {
      this.refreshCaptcha()
      this.$session.set('likpay', window.location.href)
      this.wwwtblShobeid = result.wwwtblShobeid
      this.Result = result
      if (result.tblSarfaslTypeId != 1) {
        this.FixVariz = false
      }
      if (this.$route.query.IsVgate != undefined) {
        this.$session.set('TokenVgate', true)
      }
      const mabEl = document.getElementById('Mab')
      const btnEl = document.getElementById('BtnPayment')
      const alertEl = document.getElementById('AletSumMab')
      if (
        result.mande + result.wwwJarime - result.sumMabTaeedNaShode <= 0 &&
        result.tblSarfaslTypeId == 1
      ) {
        if (mabEl) mabEl.classList.add('d-none')
        if (btnEl) btnEl.classList.add('d-none')
        if (alertEl) alertEl.classList.remove('d-none')
      } else {
        if (mabEl) mabEl.classList.remove('d-none')
      }

      if (result.mablaghGhestVam > 0) {
        this.Mablagh = result.sumGhabelPar
        this.CheckUpMablagh = result.sumGhabelPar
      } else {
      if (result.tblSarfaslTypeId != 1) {
        this.Mablagh=result.mablaghSharj>0 ? result.sumGhabelPar : ''
      }
      else{
        this.Mablagh = ''
      }
      }

      if (this.LinkId != '' && this.LinkId > 0) {
        this.CheckLinkId(this.LinkId)
      }
    },
    CheckupShenase() {
      if (this.Shenase != '') {
        this.loadingRender = true
        this.VCode = ''

        const formData = new FormData()
        formData.append('ShenaseVariz', this.$Encryption(this.Shenase))
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.state == 'Success') {
            this.applyShenaseSuccess(data.result)
            this.loadingRender = false
          } else {
            if (this.$route.query.sh) {
              if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
                this.$mySweetDefaultTost('خطا', 'شناسه واریز موجود در لینک صحیح نمیباشد.', 'error', 5000)
                this.$router.push({ name: 'LoginPage' })
              }
            } else this.$mySweetDefaultTost('خطا', 'شناسه وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
            this.refreshCaptcha()
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه واریز خالی می باشد ', 'error', 2500)
        this.refreshCaptcha()
        this.Result = null
      }
    },
    Payment() {
        if(!this.CaptchaValid){
            this.refreshCaptcha()
          this.$mySweetDefaultTost('خطا', ' متن تصویر به درستی وارد نشده است', 'error', 2000)
           return;
        }
      if (this.$ValidForm('div1')) {
        if (this.Result.tblSarfaslTypeId != 1) {
          this.SendPayment()
        } else {
          if (this.Result.sumGhabelPar || this.Result.sumGhabelPar != null) {
            if (Number(this.Mablagh) > this.Result.mande + this.Result.wwwJarime - this.Result.sumMabTaeedNaShode) {
              this.$mySweetDefault('هشدار', 'مبلغ پرداختی نمی تواند بیشتر از مانده تسهیلات باشد . ', 'warning', 2500)
            } else {
              this.FormulaJarime()
            }
          } else {
            this.$mySweetDefault('خطا', 'تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر بیشتر با ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' /شعبه تماس بگیرید', 'error', 2500)
          }
        }
      }
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val
      if (val > 0) {
        this.loadingRender = false
      }
    },
    FixVarizGhest(val) {
      
      if (this.Result.tblSarfaslTypeId != 1) {
        this.FixVariz = false
      }else{
        this.FixVariz = val
      }
    },
    FixVarizGhestHasJarime(val) {
      var jarime = this.Result.wwwJarime
      if (jarime > 0) {
        this.FixVariz = val
      }
    },
    SendPayment() {
      const nameForSend = this.stripNameQuotesForSend(this.NameFamily)
      if (this.$route.query.linkId && this.$route.query.linkId > 0) {
        // console.log('expirLink')
        this.expirLink()
      }
      this.Mablagh = this.Mablagh
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.Result.id,
        Mablagh: Number(this.Mablagh),
        SharhRiz: ' واریز | پرداخت  توسط لینک پرداخت ' + this.Description + this.Result.vCode + ' _پرداخت کننده_ ' + nameForSend,
        WwwtblAzaId: this.Result.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.Result.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.Result.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime),
        TarixGhest: this.Result.minTarGhestBedehkar,
        IsTaahodatRiz: false,
      })

      this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh)
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' واریز | پرداخت  توسط لینک پرداخت ' + ' _پرداخت کننده_ ' + nameForSend
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.Result.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh + '',
            nameForSend,
            'linkpay',
            this.Mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.Shenase + '',
            this.Result.vCode,
            'واریز | پرداخت  توسط لینک پرداخت',
            this.Result.wwwtblAzaId + '',
            this.$session.get('CustCode'),
            this.Result.wwwtblShobeid + '',
            result.idRepoMaster,
            this.Result.codeMeli.trim(),
            this.Result.nameFamily,
            this.Result.mobile,
            this.Result.codeMeli.trim()
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
          this.DeleteAllItemsCart()
        }
      })
    },
    FormulaJarime() {
      if (Number(this.Mablagh) < Number(this.CheckUpMablagh)) {
        var MablaghJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        if (this.$session.get('CustCode') == 561) {
          this.MabFormulaJarime = (Number(this.Mablagh) / Number(this.CheckUpMablagh)) * MablaghJarime
        } else {
          this.MabFormulaJarime = (Number(this.Mablagh) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        }
        this.SendPayment()
      } else {
        this.MabFormulaJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        this.SendPayment()
      }
    },
    CheckupLinkPay() {
      if (this.$route.query.sh) {
        if (this.$route.query.sh != null) {
          if (this.IsLinkPay) {
            this.loadingRender = true
            this.IsQuery = true
            this.Shenase = this.$route.query.sh + ''
            if (this.$route.query.linkId && this.$route.query.linkId > 0) {
              this.LinkId = this.$route.query.linkId
            }
            this.CheckupShenase()
          } else {
            this.$mySweetDefaultTost('خطا', 'سامانه واریز با لینک پرداخت برای شما فعال نگریدیده ، لطفا با مدیریت ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' هماهنگ کنید', 'error', 8000)
            this.loadingRender = true
          }
        } else {
          this.IsQuery = false
        }
      } else {
        this.IsQuery = false
      }
    },
    printQr() {
      var htmls = document.getElementById('qrcode')
      var htmlObject = document.createElement('div')

      // text-align: center !important; padding-top: 5cm; padding: bottom 5cm
      htmlObject.style.textAlign = 'center'
      htmlObject.style.paddingTop = '5cm'
      htmlObject.style.background = ' url(./Template/NewMenu/img/NetPaImage/LinkPay.png)'
      htmlObject.style.backgroundSize = '100%'
      htmlObject.style.height = '21cm'
      htmlObject.innerHTML = htmls.innerHTML
      html2pdf(htmlObject, {
        jsPDF: { format: 'a5' },
      })
    },
    applyLinkIdSuccess(data) {
      this.FixVariz = true
      this.IsLinkPayCustom = true
      this.Mablagh = data.amount
      this.NameFamily = data.name
      this.Mobile = data.mobile
      this.Description = data.des
    },
    CheckLinkId() {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'get',
        Action: 'LinkPay',
        Token: this.$session.get('TokenNetPa'),
      }
      DataAxios.ArryfildValue = { Id: 'Get?' + 'linkPayId=' + this.LinkId }
      this.$GetData_Header(DataAxios).then((res) => {
        if (res.status == 'Ok') {
          this.applyLinkIdSuccess(res.data)
        } else {
          this.$mySweetDefaultTost('خطا', 'لینک منقضی شده است ', 'error', 3000)
          this.$router.push({ name: 'LoginPage' })
        }
      })
    },
    expirLink() {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'get',
        Action: 'LinkPay',
        Token: this.$session.get('TokenNetPa'),
      }
      DataAxios.ArryfildValue = { Id: 'GetIsUse?' + 'linkPayId=' + this.LinkId }
      this.$GetData_Header(DataAxios).then((res) => {
        if (res.status == 'Ok') {
        }
      })
    },
    CheckInternetBankVersion() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: '/appSettings.json?nocache=123',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          'Content-Type': 'application/json',
        },
      }
      axios(config).then((result) => {
        if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
          // window.location = window.location.href + '?eraseCache=true'
          this.$router.push({ name: 'LoginPage' })
        } else {
          this.appsettings = result.data
          // console.log('😂 ~ this.appsettings:', this.appsettings)
          this.$store.state.VersionSoftware = result.data.VersionSoftware
        }
      })

      this.$store.state.loadingRender = false
      var ver = localStorage.getItem('VersionSoftware')

      if (ver == null) {
        localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
      } else {
        var OldVer = localStorage.getItem('VersionSoftware')
        var NewVer = this.$store.state.VersionSoftware
        // console.log('😂 ~ NewVer:', NewVer)
        // console.log('😂 ~ OldVer:', OldVer)
        if (OldVer != NewVer) {
          localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
          this.$swal({
            title: 'بروزرسانی جدید',
            text: 'نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود',
            icon: 'success',
            position: 'center',
            confirmButtonText: 'تایید',
            showConfirmButton: true,
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload(true)
            }
          })
        }
      }
    },
  },
  // updated() {
  //   if (document.getElementById("SelectNoeVarizi") === document.activeElement) {
  //     if (this.DepositType == 1) {
  //       document.getElementById("Shenase").focus();
  //     }
  //     if (this.DepositType == 2) {
  //       document.getElementById("VCode").focus();
  //     }
  //   }
  // },
  mounted() {
    //console.log(window.location.href);
    if (!this.$route.query.sh) {
      this.$router.push({ name: 'LoginPage' })
    }
    this.CheckInternetBankVersion()
    // if (!this.$session.get('CustCode')) {
    //   console.warn('MOUNTES')
    //   this.$router.push({ name: 'LoginPage' })
    // }
    // console.warn(window.location.href)
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      this.appsettings = result.data
      this.IsLinkPay = result.data.IsLinkPay ? result.data.IsLinkPay : false

      this.gettblCustomer()
    })

    //this.gettblCustomer()
  },
}
</script>
<style scoped>
#LinkPayPage .captcha-box {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style>
#LinkPayPage.link-pay-root {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  #LinkPayPage .link-pay-page.netpa-list-page-card-wrap--centered {
    max-width: 960px;
  }
}

#LinkPayPage .netpa-list-page-card__intro-content {
  line-height: 1.45;
}

#LinkPayPage .netpa-list-page-card__title {
  white-space: normal;
}

#LinkPayPage .netpa-list-page-card__desc {
  display: block;
  margin-top: 0.2rem;
  font-size: 12px;
}

#LinkPayPage .link-pay-toolbar {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

#LinkPayPage .link-pay-qr-toggle {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0.4rem 0.85rem;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  background: #fff;
  color: #2a3f54;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

#LinkPayPage .link-pay-qr-toggle:hover {
  background: #f8f9fb;
  border-color: #c5ced9;
}

#LinkPayPage .link-pay-form {
  width: 100%;
  padding: 0.75rem 1rem 1rem;
  box-sizing: border-box;
}

#LinkPayPage .link-pay-form > .row {
  margin-left: 0;
  margin-right: 0;
}

#LinkPayPage .link-pay-section-title {
  margin-bottom: 0.75rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px dashed #ff9800;
  color: #2a3f54;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-align: right;
}

#LinkPayPage .link-pay-section-title--spaced {
  margin-top: 1.25rem;
}

#LinkPayPage .link-pay-shenase-row {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

#LinkPayPage .link-pay-input {
  min-height: 42px;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  box-shadow: none;
}

#LinkPayPage .link-pay-input:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.12);
}

#LinkPayPage .link-pay-check-btn {
  flex: 0 0 auto;
  min-width: 4.5rem;
  min-height: 42px;
  padding: 0.45rem 0.85rem;
  border: 1px solid #2a3f54;
  border-radius: 8px;
  background: #fff;
  color: #2a3f54;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

#LinkPayPage .link-pay-check-btn:hover {
  background: #2a3f54;
  color: #fff;
}

#LinkPayPage .link-pay-result-summary {
  margin-bottom: 0.75rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #f8f9fb;
  font-size: 13px;
  line-height: 1.6;
  text-align: right;
}

#LinkPayPage .link-pay-amount-wrap {
  margin-bottom: 0.5rem;
}

#LinkPayPage .link-pay-amount-input {
  margin-bottom: 0.35rem;
}

#LinkPayPage .link-pay-amount-meta {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  text-align: center;
}

#LinkPayPage .link-pay-amount-formatted {
  color: #c72816;
  font-size: 15px;
  font-weight: 700;
}

#LinkPayPage .link-pay-amount-words {
  color: #6c757d;
  font-size: 12px;
}

#LinkPayPage .link-pay-fields {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

#LinkPayPage .link-pay-textarea {
  min-height: 72px;
  resize: vertical;
}

#LinkPayPage .link-pay-captcha-wrap {
  margin-top: 1rem;
  text-align: center;
}

#LinkPayPage .link-pay-payment-col {
  margin-top: 0;
}

#LinkPayPage .link-pay-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 12rem;
  min-height: 42px;
  padding: 0.5rem 1.25rem;
  border: none;
  border-radius: 8px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

#LinkPayPage .link-pay-submit-btn--active {
  background: #55941a;
  color: #fff;
}

#LinkPayPage .link-pay-submit-btn--active:hover:not(:disabled) {
  background: #4a8016;
}

#LinkPayPage .link-pay-submit-btn--disabled,
#LinkPayPage .link-pay-submit-btn:disabled {
  background: #adb5bd;
  color: #fff;
  cursor: not-allowed;
  opacity: 0.9;
}

#LinkPayPage .link-pay-hint-alert,
#LinkPayPage .link-pay-settled-alert {
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.55;
  text-align: right;
}

#LinkPayPage .link-pay-qr-panel {
  padding: 1rem;
}

#LinkPayPage .link-pay-qr-panel__content {
  width: 100%;
}

#LinkPayPage .link-pay-qr-panel__actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 1rem;
}

#LinkPayPage .link-pay-qr-box {
  display: inline-block;
  padding: 1.25rem 1.5rem;
  border-radius: 12px;
  background: #2a3f54;
}

#LinkPayPage .link-pay-qr-name {
  margin-bottom: 1rem;
  color: #ffc107 !important;
  font-size: 1rem;
  font-weight: 700;
}

#LinkPayPage .link-pay-qr-link {
  display: block;
  margin-top: 0.75rem;
  color: #fff !important;
  font-size: 12px;
  word-break: break-all;
}

#LinkPayPage .link-pay-print-btn {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0.45rem 1rem;
  border: 1px solid #2a3f54;
  border-radius: 8px;
  background: #fff;
  color: #2a3f54;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

#LinkPayPage .link-pay-print-btn:hover {
  background: #f0f2f5;
}

@media (max-width: 767px) {
  #LinkPayPage .link-pay-payment-col {
    margin-top: 1.25rem;
  }

  #LinkPayPage .link-pay-shenase-row {
    flex-direction: column;
  }

  #LinkPayPage .link-pay-check-btn {
    width: 100%;
  }

  #LinkPayPage .link-pay-submit-btn {
    width: 100%;
    min-width: 0;
  }
}
</style>
